var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13673_3086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58335 4.16699H9.94535C12.4847 4.16699 13.7544 4.16699 14.2364 4.62307C14.653 5.0173 14.8376 5.59806 14.7252 6.1605C14.595 6.81117 13.5584 7.54437 11.4853 9.01077L8.09812 11.4065C6.02494 12.8729 4.98834 13.6061 4.85822 14.2568C4.74574 14.8193 4.93037 15.4 5.34699 15.7943C5.82897 16.2503 7.09865 16.2503 9.63802 16.2503H10.4167M6.66669 4.16699C6.66669 5.5477 5.5474 6.66699 4.16669 6.66699C2.78598 6.66699 1.66669 5.5477 1.66669 4.16699C1.66669 2.78628 2.78598 1.66699 4.16669 1.66699C5.5474 1.66699 6.66669 2.78628 6.66669 4.16699ZM18.3334 15.8337C18.3334 17.2144 17.2141 18.3337 15.8334 18.3337C14.4526 18.3337 13.3334 17.2144 13.3334 15.8337C13.3334 14.4529 14.4526 13.3337 15.8334 13.3337C17.2141 13.3337 18.3334 14.4529 18.3334 15.8337Z",
    stroke: "#165AE3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13673_3086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistance);
export default __webpack_public_path__ + "static/media/distance.8e434e18562124c9d2e97bacc461847f.svg";
export { ForwardRef as ReactComponent };